// material-ui
import { useTheme } from '@mui/material/styles';
import magicgrologo from '../../assets/images/logo/magicgrologo.png';
import { Box } from '@mui/material';


// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        // Add your margin-left here
        marginLeft: '12px',
        marginTop: '20px'
      }}
    >
       <img
                  
                  width={180}
                  height={75}
                  src={magicgrologo }
                  alt="Logo"
        />
    </Box>
  );
}
